import React,{useEffect} from "react";
import "../Style/Contactus.css";
import NavBar from "../Components/HomeSections/NavBar";
import Header from "../Components/HomeSections/Header";
import Footer from "../Components/HomeSections/Footer";
import ContactForm from "../Components/HomeSections/ContactForm";
import { Helmet } from "react-helmet";

const Contactpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
        <Helmet>
        <title>
          Contact Di Henneberry | Henneberry Property Group Sydney
        </title>
        <meta
          name="description"
          content="Get in touch with Di Henneberry for expert advice on property management, sales strategy, and off-market opportunities across Sydney and NSW."
        />
      </Helmet>
      <div className="banner_bg">
        <NavBar />
        <Header />
        <h1 className="d-flex align-items-center justify-content-center " style={{color:"#f7e0b3"}}>
          Contact Us
        </h1>
      </div>
      <div className="container mt-5 mb-5">
        <div className="contactpage">
          <ContactForm />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contactpage;
